<template>
  <v-app >
    <v-main :class="background_colour">

      <v-app-bar dark color="#106B9E" height="80" class="mb-4">
        <v-container class="mt-6">
          <v-row> 

            <v-col cols="3"> 
              <v-card color="#106B9E" flat align="center"> 
                <v-btn text small @click="change_status()"> 
                  <v-icon large> mdi-history </v-icon> 
                </v-btn> 
              </v-card>
            </v-col>

            <v-col cols="6"> 
              <v-card color="#106B9E" align="center" justify="center" class="title" flat> {{ $t("nav_bar_title") }} </v-card> 
            </v-col>

            <v-col cols="3">
              <v-card color="#106B9E"  flat align="center">
                <v-select v-model="language" :items="languages" @change="change_language()">
                  <template slot="item" slot-scope="languages"> 
                      {{languages.item.name}}
                  </template>

                  <template slot="selection" slot-scope="languages">
                      {{languages.item.name}}
                  </template>

                </v-select>
              </v-card>
            </v-col>

          </v-row>
        </v-container>
      </v-app-bar>
      
      <starting-screen
        v-if="(starting_screen && !(status_screen))"
        v-on:starting_keywords="confirm($event)"
      >  
      </starting-screen>

      <question-screen
        v-if="(question_screen && !(status_screen))"
        :question="relevant_questions[0]"
        :disabled="allready_asked_id.includes(relevant_questions[0].id)"
        v-on:button_pressed="confirm($event)"
        v-on:go_back="go_back3()"
        v-on:restart="reset()"
      > 
      </question-screen>
      
      <end-screen
        v-if="(end_screen && !(status_screen))"
        :keywords="get_all_problem_keywords()"
        v-on:restart="reset()"
        v-on:go_back="go_back3()"
      >
      </end-screen>

      <status-screen
        v-if="status_screen"
        :status="status"
        v-on:go_back="go_back3()"
        v-on:restart="reset()"
      >
      </status-screen>
    </v-main>

    <v-footer height="100" color="#05273B" dark align="end" d-flex align-end>
      <v-row cols="12">
        <v-col cols="4" align="center" justify="center">
          <a href="https://www.picockpit.com/" target="_new"> <v-btn color="#D67900"><v-icon class="pr-2"> mdi-airplane </v-icon> PICOCKPIT.COM </v-btn></a>
        </v-col>
        <v-col cols="4" align="center" justify="center">
          {{ $t('advert')}}
        </v-col>
        <v-col cols="4" align="center" justify="center">
          {{ $t('telefon') }}
          <br>
          {{ $t('email') }}
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
import Questions from '../questions'
import questionScreen from './question-screen.vue';
import startingScreen from './starting-screen.vue'
import endScreen from './end-screen.vue'
import i18n from '../i18n'
import StatusScreen from './status-screen.vue';
export default {
  components: {
    questionScreen,
    startingScreen, 
    endScreen,
    StatusScreen
  },
  name: 'troubleshooter',
  data: () => ({
    questions: Questions.questions,
    allready_asked_id: [],
    allready_asked_detailed: [],
    relevant_questions: [],
    status: [],
    
    
    starting_screen: true,
    question_screen:  false,
    end_screen: false,
    status_screen: false,
    current_screen: null,

    background_colour: 'secondary',

    keywords: [],
    
    language: {name: 'English', short: 'en'},
    languages: [ 
      {name: 'English', short: 'en'},
      {name: 'Deutsch', short: 'de'},
      {name: 'Italiano', short: 'it'},
      {name: 'Français', short: 'fr'},
      {name: 'Español', short: 'sp'},
      {name: 'Português', short: 'pr'},
      {name: 'Ελληνικά', short: 'gr'},
      {name: 'Nederlands', short: 'ne'},
      {name: 'Svenska', short: 'sw'},
      {name: 'русский', short: 'ru'},
      {name: 'Polski', short: 'pl'},
      {name: '中文', short: 'ch'},
      {name: '日本', short: 'jp'},
    ]
  
  }),
  methods: {
    confirm(keyword_changes) {
      if (!(this.starting_screen)) {
        // Save to allready asked
        this.allready_asked_detailed.push({id: this.relevant_questions[0].id, keywords_at_time: JSON.parse(JSON.stringify(this.keywords))})
        this.allready_asked_id.push(this.relevant_questions[0].id)

        if (keyword_changes.length > 2) {
          this.status.push([this.$t(this.relevant_questions[0].question), this.$t(keyword_changes[2])])
        }
        
        this.interpret_question_answers(keyword_changes)
        


        if (!(this.check_if_problem_detected())) {
          this.choose_questions()
          this.relevant_questions.shift()
          if (this.relevant_questions.length === 0) {
            if (this.check_for_maybe()) {
              this.convert_maybe()
                if (!(this.check_if_problem_detected())) {
                  this.choose_questions()
                }
                else {
                  this.question_screen = false
                  this.end_screen = true
                }
              
            } 
            else{
              this.question_screen = false
              this.end_screen = true
            }
            
          } 
        }

        else {
          this.question_screen = false
          this.end_screen = true
        } 

      }

      else {
        this.starting_screen = false
        this.question_screen = true
        this.interpret_question_answers(keyword_changes)
        this.choose_questions()
      }

    },

    check_for_maybe() {
      for (let keyword_nr = 0; keyword_nr < this.keywords.length; keyword_nr++) {
        if (this.keywords[keyword_nr].includes("maybe_")) {
          return true
        }
      }
      return false
    },

    convert_maybe() {
      for (let keyword_nr = 0; keyword_nr < this.keywords.length; keyword_nr++) {
        if (this.keywords[keyword_nr].includes("maybe_")) {
          this.keywords[keyword_nr] = this.keywords[keyword_nr].split('maybe_')[1]
          console.log(this.keywords)
        } 
      }
    },


    interpret_question_answers(keyword_changes) {
      // First list is keywords that should be added
      
      for (let i = 0; i < keyword_changes[0].length; i++) {
        this.keywords.push(keyword_changes[0][i])
      }

      // Second list is keywords that should be removed
      
      for (let i = 0; i < keyword_changes[1].length; i++) {
        this.keywords = this.keywords.filter(e => e !== keyword_changes[1][i])
      }
    },


    check_if_problem_detected() {
      for (let i = 0; i < this.keywords.length; i++) { 
        if (!(this.keywords[i].includes("maybe_problem_"))) { 
          if (this.keywords[i].includes("problem_")) {
            this.end_screen = true
            return true
          }
        }
      }
    },


    choose_questions() {
      for (let question_nr = 0; question_nr < this.questions.length; question_nr++) {
        if (this.check_if_in_keywords (this.questions[question_nr])) {
          if (!(this.allready_asked_id.includes(this.questions[question_nr].id))) {
            if (!(this.relevant_questions.includes(this.questions[question_nr]))) {
              this.relevant_questions.push(this.questions[question_nr])
            }     
          }
        }
      }
    },

    check_if_in_keywords(question) {
      let keyword_status = []
      for (let keyword_nr = 0; keyword_nr < question.preq_keywords.length; keyword_nr ++) {
        if (this.keywords.includes(question.preq_keywords[keyword_nr])) {
          keyword_status.push(true)
        }      
        else {
          keyword_status.push(false)
        }
      }
      return !(keyword_status.includes(false))
    },


    get_all_problem_keywords() {
      let p_keywords = []
      for (let i = 0; i < this.keywords.length; i++) {   
        if (!(this.keywords[i].includes("maybe_problem_"))) {      
          if (this.keywords[i].includes("problem_")) {
            p_keywords.push(this.keywords[i])
          }
        }
      }
      if (p_keywords.length < 1) {
        p_keywords = ['problem_not_detected']
      }
      return p_keywords
    },

    change_language() {
      i18n.locale = this.language.short
    },
    
    go_back3() {
      if (this.end_screen) {
        this.end_screen = false
        this.question_screen = true
      }
      if (this.allready_asked_detailed.length > 0) {
        this.allready_asked_id = []
        for (let id_nr = 0; id_nr < this.allready_asked_detailed.length - 1 ; id_nr++) {
          this.allready_asked_id.push(this.allready_asked_detailed[id_nr].id)
        }
        this.keywords = this.allready_asked_detailed.at(-1).keywords_at_time
        this.allready_asked_detailed.pop()
        this.status.pop()

        this.relevant_questions = []
        this.choose_questions()
      }
      else {
        this.starting_screen = true
        this.question_screen = false
        this.keywords = []
        this.allready_asked_detailed = []
        this.allready_asked_id = []
        this.relevant_questions = []
      }
    },


    change_status() {
      this.status_screen = !(this.status_screen)
      if (this.background_colour === 'primary') {
        this.background_colour = 'secondary'
      }
      else {
        this.background_colour = 'primary'
      }
    },

    // From Stack Overflow -- how to remove Item from list
    removeItemOnce(arr, value) {
      arr = arr.filter(item => item !== value)
      return arr;
    },

    reset() {
      this.allready_asked_id = [],
      this.allready_asked_detailed = [],
      this.relevant_questions = [],
      this.status = [],
    
    
      this.starting_screen = true,
      this.question_screen =  false,
      this.end_screen = false,
      this.status_screen = false,
      this.current_screen = null,

      this.background_colour = 'secondary',

      this.keywords = []
    }
  },
};


</script>
